function init( skip_sector = false, selector = 'form.camper-search' )
{
  const forms = document.querySelectorAll( selector )

  if( !forms ) return

  forms.forEach( form => {
    form.addEventListener( 'change', () => {

      if( !skip_sector ){

        const sector = form.elements.sector.selectedOptions[ 0 ]

        form.setAttribute( 'action', sector.getAttribute( 'data-value' ) )
      }

      form.submit()
    })

  })

}

export default {
  init
}
